/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.upsellAddToCart();
    
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  // Attach the click event handler using event delegation
  upsellAddToCart() {
    document.querySelector('cart-drawer').addEventListener('click', (event) => {
      // Check if the clicked element is a .variant-button
      if (event.target.matches('.variant-button')) {
        const button = event.target;

        // Retrieve the hidden input with the variant ID within the same form
        const form = button.closest('form');
        const variantIdInput = form.querySelector('input[name="id"]');
        const variantId = variantIdInput ? variantIdInput.value : null;

        if (variantId) {
          // Call the addToCart method with the variant ID
          this.addToCart(variantId);
        } else {
          alert('Variant ID is missing');
        }
      }
    });
  }

  // Add to cart method
  addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then((response) => {
      console.log(response);
      let sec_url = window.location.pathname + "?section_id=cart-drawer";
      fetch(sec_url)
      .then((response) => response.text())
      .then((responseText) => {
        let html = new DOMParser().parseFromString(responseText, "text/html");
        console.log(html);
        $("cart-drawer cart-form").html("");

        let box = document.querySelector("cart-drawer cart-form");
        box.insertAdjacentHTML(
          "beforeend",
          html.querySelector("cart-drawer cart-form").innerHTML
        );

        $('.cc-popup-close').on('click', function() {
          $(".cart-drawer-modal").removeClass('cc-popup--visible');
          $("body").removeClass("cc-popup-no-scroll cc-popup-no-scroll-pad-right");
        });

        let bubble_count = $("cart-drawer .cart-drawer__title-count").data("cart_item") || 0;
        let bubble_html = '<span class="cart-link__count">'+ bubble_count +'</span>';
        let cartIcon = document.querySelector(".cart-link__icon");

        if (cartIcon) {
          cartIcon.insertAdjacentHTML("beforeend", bubble_html);
        }

        if (response.ok) {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
            bubbles: true
          }));
          document.querySelector('.js-cart-drawer').open();
        }
      });
      return response.json();
    })
    .then((data) => {
      if (data.status && data.status === 422) {
        console.error('Error:', data.description);
        alert(data.description);
      }
    })
    .catch((error) => {
      console.error('There was a problem with the fetch operation:', error);
    });
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
